import { put, select, call, fork, takeLatest, all } from "redux-saga/effects";
import moment from "moment-timezone";

import {
  PLANNING_MODAL_LOADING,
  PLANNING_GET_ALL_SECTORSLIST,
  PLANNING_SET_ALL_SECTORSLIST,
  PLANNING_GET_TYPES_VISIT,
  PLANNING_SET_TYPES_VISIT,
  PLANNING_AGENDA_LOADING,
  PLANNING_SET_KEY_FILTER_SELECTED,
  PLANNING_SET_FILTERS,
  PLANNING_SET_CURRENT_FILTERS,
  PLANNING_SET_EVENTS,
  PLANNING_SEND_NEW_EVENT,
  PLANNING_UPDATE_EVENT,
  PLANNING_MOVE_DAY_EVENTS,
  PLANNING_DELETE_EVENT,
  PLANNING_SELECT_EMAIL,
  PLANNING_PRE_SELECT_USER,
  PLANNING_SET_REQUEST_RESPONSE,
  PLANNING_SET_KEY_PDC_FILTER_SELECTED,
  PLANNING_SET_KEY_SECTOR_FILTER_SELECTED,
  PLANNING_GET_AVAILABLE_DATE_RANGE,
  PLANNING_SET_AVAILABLE_DATE_RANGE,
  PLANNING_SELECT_USER_SECTOR,
  PLANNING_SELECT_USER,
  PLANNING_SET_USER_PDCSLIST,
  PLANNING_GET_EVENT_TYPES,
  PLANNING_SET_EVENT_TYPES,
  PLANNING_SET_CURRENT_DATE_RANGE,
  PLANNING_SET_LUCCA_VACATION_DAYS,
  PLANNING_SELECT_PDC_ID
} from "./../types";

import _ from "lodash";
import {
  createNewEventApi,
  deleteEventApi,
  getAllSectorsApi,
  getAvailableDateRangeApi,
  getEventsApi,
  getEventTypeApi,
  getRetailersOfSurveysApi,
  getDistinctSectorsApi,
  getTypesVisitApi,
  getUsersOfManager,
  getUserSectorsApi,
  updateEventApi,
  getSector_pdcsApi,
  getLuccaPlanningVacationsApi
} from "./planning.api";
import { GSK_PHARMA_ID } from "../../configs/constants";

const getPlanningState = state => state.planning || {};
const getAuthState = state => state.auth || {};
const getCurrentClientState = state => state.currentClient || {};
const getUserInfosState = state => state.userInfos || {};
// const getSectors = state => state.sectors;

const isMovablePlanningEvent = (event, sourceDate) => {
  return (
    event &&
    event._id &&
    event.start_date &&
    event.end_date &&
    moment(event.start_date).isSame(sourceDate, "day") &&
    moment(event.end_date).isAfter(moment()) &&
    !event.visit_id &&
    !event.not_planned &&
    !event.type
  );
};

const moveEventToDate = (event, targetDate) => {
  const startDate = moment(event.start_date);
  const endDate = moment(event.end_date);
  const movedStartDate = moment(targetDate)
    .hour(startDate.hour())
    .minute(startDate.minute())
    .second(startDate.second())
    .millisecond(startDate.millisecond());

  return {
    client_id: event.client_id,
    sector_id: event.sector_id,
    pdc_id: event.pdc_id,
    user_id: event.user_id,
    end_date: movedStartDate
      .clone()
      .add(endDate.diff(startDate))
      .format(),
    start_date: movedStartDate.format(),
    event_type_id: event.event_type_id,
    rdv: event.rdv,
    _id: event._id
  };
};

function* getEvents() {
  try {
    yield put({ type: PLANNING_AGENDA_LOADING, loading: true });
    const statePlanning = yield select(getPlanningState);
    const stateAuth = yield select(getAuthState);
    const stateCurrentClient = yield select(getCurrentClientState);
    const stateUserInfos = yield select(getUserInfosState);

    const isTerrain = stateUserInfos.role_id === 4;
    const userEmail = stateUserInfos.email;
    const data = yield call(
      getEventsApi,
      statePlanning,
      stateAuth.token,
      stateCurrentClient.id,
      isTerrain && userEmail
    );

    const events = data.map((event, index) => {
      const newEvent = event;
      newEvent.start = event.start_date;
      newEvent.end = event.end_date;
      newEvent.id = index;
      newEvent.title = event.pdc_label;
      newEvent.visitType = event.event_sous_type_label;
      newEvent.visits = 0;

      return newEvent;
    });

    yield put({ type: PLANNING_SET_EVENTS, payload: events });
    yield call(getLuccaVacationDays, isTerrain && userEmail);
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  }
}

function* getLuccaVacationDays(selectedEmail) {
  try {
    const statePlanning = yield select(getPlanningState);
    const stateAuth = yield select(getAuthState);
    const planningState = selectedEmail ? { ...statePlanning, selectedEmail } : statePlanning;
    const vacationDays = yield call(getLuccaPlanningVacationsApi, planningState, stateAuth.token);

    yield put({ type: PLANNING_SET_LUCCA_VACATION_DAYS, payload: vacationDays });
  } catch (e) {
    console.log(e.message);
    yield put({ type: PLANNING_SET_LUCCA_VACATION_DAYS, payload: [] });
  }
}

function* getSectorFilterValues(action) {
  const state = yield select(getPlanningState);
  const stateCurrentClient = yield select(getCurrentClientState);
  const statePlanning = yield select(getPlanningState);
  // const { selectedSector } = state;

  const data = yield call(getDistinctSectorsApi, action.date, stateCurrentClient.id);
  const allSectorsFiltered = [];
  const getUserSectors = yield call(getUserSectorsApi, action.date, stateCurrentClient.id);

  const sectorsListFilter = statePlanning.allSectorsList.filter(sector =>
    getUserSectors.map(userSector => userSector.label).includes(sector.sector_label)
  );

  sectorsListFilter.forEach(sector => {
    const salepointResult = sector.salepoints.filter(salepoint => data.includes(salepoint.retailer_id));
    const usersResult = sector.users.filter(user => user.email === state.selectedEmail);

    if (!_.isEmpty(salepointResult) && !_.isEmpty(usersResult)) allSectorsFiltered.push(sector);
  });

  yield put({
    type: PLANNING_SET_FILTERS,
    values: allSectorsFiltered,
    key: "sector_label"
  });
}

function* getPdcFilterValues(action) {
  try {
    const state = yield select(getPlanningState);
    const stateCurrentClient = yield select(getCurrentClientState);
    const statePlanning = yield select(getPlanningState);
    const { selectedSector } = state;
    const data = yield call(getRetailersOfSurveysApi, action.date, selectedSector, stateCurrentClient.id);
    const allPdcFiltered = [];

    statePlanning.allSectorsList.forEach(sector => {
      if (sector.sector_label === selectedSector) {
        sector.salepoints.forEach(salepoint => {
          if (data.includes(salepoint.retailer_id)) allPdcFiltered.push(salepoint);
        });
      }
    });

    yield put({
      type: PLANNING_SET_FILTERS,
      values: allPdcFiltered,
      key: "pdc_label"
    });
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  }
}

function* getFilterValues() {
  try {
    yield put({ type: PLANNING_AGENDA_LOADING, loading: true });
    const statePlanning = yield select(getPlanningState);
    const stateAuth = yield select(getAuthState);
    const stateCurrentClient = yield select(getCurrentClientState);
    const stateUserInfos = yield select(getUserInfosState);
    let values = [];

    if (statePlanning.keyFilterSelected === "type") {
      values = statePlanning.typesVisit.map(visit => visit.sous_type_fr);
    } else if (statePlanning.keyFilterSelected === "pdc_label") {
      const selectedSector = yield statePlanning.allSectorsList.filter(
        sector => sector.sector_label === statePlanning.selectedSector
      );

      if (!_.isEmpty(selectedSector)) values = selectedSector[0].salepoints;
    } else if (statePlanning.keyFilterSelected === "sector_label") {
      values = statePlanning.allSectorsList;
      if (stateUserInfos.role_id === 4) {
        values = stateUserInfos.sectors;
      } else {
        values = yield call(getSectorFilterValues, { date: new Date() });
      }
    } else if (statePlanning.keyFilterSelected === "email") {
      values = yield call(getUsersOfManager, stateAuth.token, stateCurrentClient.id, stateUserInfos);
    }
    if (values && values.length <= 0) {
      throw new Error("Il n'y a pas d'utilisateurs dans l'effectif pour ce dossier");
    }
    yield put({
      type: PLANNING_SET_FILTERS,
      values: values,
      key: statePlanning.keyFilterSelected
    });
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  }
}
function* storeUser(email) {
  yield put({
    type: PLANNING_SELECT_EMAIL,
    payload: email
  });
  yield put({
    type: PLANNING_SET_CURRENT_FILTERS,
    currentFilters: { user_email: email }
  });
  yield put({
    type: PLANNING_SELECT_PDC_ID,
    paylaod: null
  });
}
function* selectUserSector(action) {
  try {
    yield put({ type: PLANNING_AGENDA_LOADING, loading: true });

    const stateCurrentClient = yield select(getCurrentClientState);
    const selectedSector = action.payload;
    const planningState = yield select(getPlanningState);
    const userSectorsList = planningState.allSectorsList;
    const stateAuth = yield select(getAuthState);
    const selectedSectorData = userSectorsList.find(
      sector => selectedSector === sector.sector_label && sector.client_id === stateCurrentClient.id
    );
    if (!selectedSectorData) {
      throw new Error("sector not defined");
    }
    const selectedSectorId = selectedSectorData.sector_id;
    const selectedClientId = stateCurrentClient.id;

    const pdcsOfSector = yield call(
      getSector_pdcsApi,
      { sector_id: selectedSectorId, client_id: selectedClientId },
      stateAuth.token
    );
    const pdcsListOfSelectedSector = pdcsOfSector;

    const pdcsListWithFrequency =
      stateCurrentClient.id !== GSK_PHARMA_ID
        ? pdcsListOfSelectedSector.filter(pdc => pdc.frequency)
        : pdcsListOfSelectedSector;

    yield put({ type: PLANNING_SET_USER_PDCSLIST, payload: pdcsListWithFrequency });
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  } catch (e) {
    console.log(e);
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  }
}
function* selectUser(action) {
  try {
    yield put({ type: PLANNING_AGENDA_LOADING, loading: true });

    const stateCurrentClient = yield select(getCurrentClientState);
    const selectedEmail = action.payload;
    // yield put({
    //   type: PLANNING_SET_FILTERS,
    //   values: action.payload,
    //   key: "email"
    // });

    yield call(storeUser, selectedEmail);
    const sectorsList = yield call(getAllSectorsApi, selectedEmail, stateCurrentClient.id);
    yield put({ type: PLANNING_SET_ALL_SECTORSLIST, payload: sectorsList });

    const selectedSectorLabel =
      Array.isArray(sectorsList) && sectorsList.length > 0 ? sectorsList[0].sector_label : undefined;

    yield put({ type: PLANNING_SELECT_USER_SECTOR, payload: selectedSectorLabel });

    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  } catch (e) {
    console.log(e);
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  }
}

function* preSelectUserTerrain() {
  try {
    yield put({ type: PLANNING_AGENDA_LOADING, loading: true });
    const stateCurrentClient = yield select(getCurrentClientState);
    const stateUserInfos = yield select(getUserInfosState);
    const userEmail = stateUserInfos.email;

    yield put({
      type: PLANNING_SET_FILTERS,
      values: [stateUserInfos],
      key: "email"
    });

    yield put({ type: PLANNING_SELECT_EMAIL, payload: userEmail });
    const sectorsList = yield call(getAllSectorsApi, userEmail, stateCurrentClient.id);
    yield put({ type: PLANNING_SET_ALL_SECTORSLIST, payload: sectorsList });

    const selectedSectorLabel =
      Array.isArray(sectorsList) && sectorsList.length > 0 ? sectorsList[0].sector_label : undefined;

    yield put({ type: PLANNING_SELECT_USER_SECTOR, payload: selectedSectorLabel });

    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  } catch (e) {
    console.log(e);
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  }
}
function* preSelectUser() {
  try {
    yield put({ type: PLANNING_AGENDA_LOADING, loading: true });

    const stateAuth = yield select(getAuthState);
    const stateCurrentClient = yield select(getCurrentClientState);
    const stateUserInfos = yield select(getUserInfosState);
    const isTerrain = stateUserInfos.role_id === 4;
    const isClient = stateUserInfos.role_id === 5;
    if (isTerrain) {
      yield call(preSelectUserTerrain);
    } else {
      const values = yield call(getUsersOfManager, stateAuth.token, stateCurrentClient.id, stateUserInfos);

      if (values.length <= 0) {
        if (!isClient) {
          alert("Dossier sans utilisateur dans l'effectif Upsell pour ce dossier");
        }

        yield call(storeUser, null);
        throw new Error("Il n'y a pas d'utilisateurs dans l'effectif Upsell pour ce dossier");
      }

      const selectedEmail = values[0].email;
      yield put({
        type: PLANNING_SET_FILTERS,
        values: values,
        key: "email"
      });

      yield call(storeUser, selectedEmail);
      const sectorsList = yield call(getAllSectorsApi, selectedEmail, stateCurrentClient.id);
      yield put({ type: PLANNING_SET_ALL_SECTORSLIST, payload: sectorsList });

      const selectedSectorLabel =
        Array.isArray(sectorsList) && sectorsList.length > 0 ? sectorsList[0].sector_label : undefined;

      yield put({ type: PLANNING_SELECT_USER_SECTOR, payload: selectedSectorLabel });

      yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
    }
  } catch (e) {
    console.log(e);
    yield put({ type: PLANNING_AGENDA_LOADING, loading: false });
  }
}

function* getAllSectorsList() {
  try {
    yield put({ type: PLANNING_MODAL_LOADING, loading: true });
    const stateCurrentClient = yield select(getCurrentClientState);
    const statePlanning = yield select(getPlanningState);
    const sectorsList = yield call(getAllSectorsApi, statePlanning.selectedEmail, stateCurrentClient.id);

    yield put({ type: PLANNING_SET_ALL_SECTORSLIST, payload: sectorsList });
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  } catch (e) {
    console.log(e);
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  }
}

function* getTypesVisitList() {
  try {
    const currentClientState = yield select(getCurrentClientState) || {};
    yield put({ type: PLANNING_MODAL_LOADING, loading: true });
    const typesVisitList = yield call(getTypesVisitApi, currentClientState.id);
    yield put({ type: PLANNING_SET_TYPES_VISIT, payload: typesVisitList });
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  } catch (e) {
    console.log(e);
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  }
}

function* getEventTypesList() {
  try {
    const currentClientState = yield select(getCurrentClientState) || {};
    yield put({ type: PLANNING_MODAL_LOADING, loading: true });
    const eventTypesList = yield call(getEventTypeApi, currentClientState.id);
    yield put({ type: PLANNING_SET_EVENT_TYPES, payload: eventTypesList });
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  } catch (e) {
    console.log(e);
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  }
}

function* updateEvent(action) {
  try {
    yield put({ type: PLANNING_MODAL_LOADING, loading: true });
    const stateAuth = yield select(getAuthState);
    const statePlanning = yield select(getPlanningState);
    let event = action.event;
    //Case event modified by clicking on event not by dragging event in planning
    if (statePlanning.selectedTypeVisit) {
      const selectedTypeVisit = yield statePlanning.eventTypes.find(
        visit => visit.sous_type_fr === statePlanning.selectedTypeVisit
      );

      event.event_type_id = selectedTypeVisit.id;
    }

    const data = yield call(updateEventApi, event, stateAuth.token);
    if (action.updateMethod === "click") {
      yield call(storeUser, statePlanning.selectedEmail);
    }

    // if (data.status === 0) yield call(getEvents);
    yield call(getEvents);
    yield put({ type: PLANNING_SET_REQUEST_RESPONSE, response: data });
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  }
}

function* moveDayEvents(action) {
  try {
    yield put({ type: PLANNING_MODAL_LOADING, loading: true });
    const stateAuth = yield select(getAuthState);
    const statePlanning = yield select(getPlanningState);
    const sourceDate = moment(action.sourceDate);
    const targetDate = moment(action.targetDate);

    if (!sourceDate.isValid() || !targetDate.isValid()) {
      yield put({
        type: PLANNING_SET_REQUEST_RESPONSE,
        response: { status: 0, text: "Veuillez sélectionner une date de départ et une date d'arrivée." }
      });
      yield put({ type: PLANNING_MODAL_LOADING, loading: false });
      return;
    }

    if (sourceDate.isSame(targetDate, "day")) {
      yield put({
        type: PLANNING_SET_REQUEST_RESPONSE,
        response: { status: 0, text: "La date d'arrivée doit être différente de la date de départ." }
      });
      yield put({ type: PLANNING_MODAL_LOADING, loading: false });
      return;
    }

    if (targetDate.isBefore(moment().startOf("day"))) {
      yield put({
        type: PLANNING_SET_REQUEST_RESPONSE,
        response: { status: 0, text: "La date d'arrivée ne peut pas être dans le passé." }
      });
      yield put({ type: PLANNING_MODAL_LOADING, loading: false });
      return;
    }

    const eventsToMove = (statePlanning.events || []).filter(event => isMovablePlanningEvent(event, sourceDate));

    if (eventsToMove.length === 0) {
      yield put({
        type: PLANNING_SET_REQUEST_RESPONSE,
        response: {
          status: 0,
          text: "Aucun événement planifié, non visité et à venir n'a été trouvé pour cette journée."
        }
      });
      yield put({ type: PLANNING_MODAL_LOADING, loading: false });
      return;
    }

    const results = [];
    for (let i = 0; i < eventsToMove.length; i++) {
      const event = moveEventToDate(eventsToMove[i], targetDate);
      const result = yield call(updateEventApi, event, stateAuth.token);
      results.push(result);
    }

    const failedResults = results.filter(result => result.status === 0);

    if (failedResults.length === 0) {
      yield call(getEvents);
      yield put({
        type: PLANNING_SET_REQUEST_RESPONSE,
        response: {
          status: 1,
          text: `${eventsToMove.length} événement(s) déplacé(s) du ${sourceDate.format("DD/MM/YYYY")} au ${targetDate.format(
            "DD/MM/YYYY"
          )}.`
        }
      });
    } else {
      if (failedResults.length < eventsToMove.length) yield call(getEvents);
      yield put({
        type: PLANNING_SET_REQUEST_RESPONSE,
        response: {
          status: 0,
          text: `${failedResults.length} événement(s) n'ont pas pu être déplacé(s). ${failedResults[0].text || ""}`
        }
      });
    }

    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  }
}

function* deleteEvent(action) {
  try {
    yield put({ type: PLANNING_MODAL_LOADING, loading: true });
    const stateAuth = yield select(getAuthState);
    const statePlanning = yield select(getPlanningState);
    const data = yield call(deleteEventApi, action.event, stateAuth.token);

    yield call(storeUser, statePlanning.selectedEmail);
    yield call(getEvents);
    yield put({ type: PLANNING_SET_REQUEST_RESPONSE, response: data });
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  }
}

function* createNewEvent(action) {
  try {
    yield put({ type: PLANNING_MODAL_LOADING, loading: true });

    const statePlanning = yield select(getPlanningState);
    const stateAuth = yield select(getAuthState);
    const stateCurrentClient = yield select(getCurrentClientState);
    let selectedSectorId = action.event.sector_id;
    if (!selectedSectorId) {
      const selectedSectorLabel = statePlanning.selectedSector || "";
      const selectedSector =
        statePlanning.allSectorsList.find(sector => {
          const sectorLabel = sector.sector_label || "";
          return sectorLabel.trim() === selectedSectorLabel.trim();
        }) || {};
      selectedSectorId = selectedSector.sector_id;
    }

    let selectedPdcId = action.event.pdc_id || statePlanning.selectedPdcId;

    let selectedTypeVisitId = action.event.event_type_id;
    if (!selectedTypeVisitId) {
      selectedTypeVisitId = yield statePlanning.eventTypes.find(
        visit => visit.sous_type_fr === statePlanning.selectedTypeVisit
      ).id;
    }
    const user = statePlanning.usersList.find(user => {
      return user.email === statePlanning.selectedEmail;
    });

    const userId = user === undefined ? alert("pas de user") : user._id;

    let event = {
      client_id: stateCurrentClient.id,
      sector_id: selectedSectorId,
      pdc_id: selectedPdcId,
      user_id: userId,
      end_date: action.event.end_date,
      start_date: action.event.start_date,
      event_type_id: selectedTypeVisitId,
      rdv: action.event.rdv
    };

    const data = yield call(createNewEventApi, event, stateAuth.token);

    yield put({ type: PLANNING_SET_REQUEST_RESPONSE, response: data });

    if (data.status === 1) {
      yield call(storeUser, statePlanning.selectedEmail);
      yield call(getEvents);
    }
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  } catch (e) {
    console.log("", e);
    yield put({ type: PLANNING_MODAL_LOADING, loading: false });
  }
}

function* getAvailableDateRange() {
  try {
    const stateToken = yield select(getAuthState);
    const data = yield call(getAvailableDateRangeApi, stateToken);

    yield put({
      type: PLANNING_SET_AVAILABLE_DATE_RANGE,
      payload: data
    });
  } catch (e) {
    console.log(e.message);
  }
}

function* watchGetUserSectorsList() {
  yield takeLatest(PLANNING_GET_ALL_SECTORSLIST, getAllSectorsList);
}

function* watchGetTypesVisitList() {
  yield takeLatest(PLANNING_GET_TYPES_VISIT, getTypesVisitList);
}

function* watchGetEventTypesList() {
  yield takeLatest(PLANNING_GET_EVENT_TYPES, getEventTypesList);
}

function* watchPreSelectUser() {
  yield takeLatest(PLANNING_PRE_SELECT_USER, preSelectUser);
}
function* watchSelectUser() {
  yield takeLatest(PLANNING_SELECT_USER, selectUser);
}
function* watchSelectUserSector() {
  yield takeLatest(PLANNING_SELECT_USER_SECTOR, selectUserSector);
}

function* watchSetKeyFilterSelected() {
  yield takeLatest(PLANNING_SET_KEY_FILTER_SELECTED, getFilterValues);
}

function* watchFetchEvents() {
  yield takeLatest(PLANNING_SET_CURRENT_FILTERS, getEvents);
}

function* watchCreateNewEvent() {
  yield takeLatest(PLANNING_SEND_NEW_EVENT, createNewEvent);
}

function* watchUpdateEvent() {
  yield takeLatest(PLANNING_UPDATE_EVENT, updateEvent);
}

function* watchMoveDayEvents() {
  yield takeLatest(PLANNING_MOVE_DAY_EVENTS, moveDayEvents);
}

function* watchDeleteEvent() {
  yield takeLatest(PLANNING_DELETE_EVENT, deleteEvent);
}

function* watchSetKeyPdcFilterSelected() {
  yield takeLatest(PLANNING_SET_KEY_PDC_FILTER_SELECTED, getPdcFilterValues);
}

function* watchSetKeySectorFilterSelected() {
  yield takeLatest(PLANNING_SET_KEY_SECTOR_FILTER_SELECTED, getSectorFilterValues);
}

function* watchGetAvailableDateRange() {
  yield takeLatest(PLANNING_GET_AVAILABLE_DATE_RANGE, getAvailableDateRange);
}

function* watchSetRangeDate() {
  yield takeLatest(PLANNING_SET_CURRENT_DATE_RANGE, getEvents);
}
export default function* root() {
  yield all([
    fork(watchSelectUserSector),
    fork(watchGetUserSectorsList),
    fork(watchGetTypesVisitList),
    fork(watchGetEventTypesList),
    fork(watchSetKeyFilterSelected),
    fork(watchFetchEvents),
    fork(watchCreateNewEvent),
    fork(watchUpdateEvent),
    fork(watchMoveDayEvents),
    fork(watchDeleteEvent),
    fork(watchPreSelectUser),
    fork(watchSelectUser),
    fork(watchSetKeyPdcFilterSelected),
    fork(watchSetKeySectorFilterSelected),
    fork(watchGetAvailableDateRange),
    fork(watchSetRangeDate)
  ]);
}



// WEBPACK FOOTER //
// src/redux/sagas/planningSagas.js